"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EMPTY = "";
/**
 * Appends an index to a path prefix.
 * @param {string | undefined} prefix - The prefix to append the segment to, or undefined if no prefix exists.
 * @param {string} digits - The digits to append to the prefix.
 * @returns {string} The concatenated path, with the digits appended to the prefix (if provided).
 */
var appendPathIndex = function (prefix, digits) { return "".concat(prefix !== null && prefix !== void 0 ? prefix : EMPTY, "[").concat(digits, "]"); };
exports.default = appendPathIndex;
